/** §21 — a spinner always ships with accessible status text. */
export function Spinner({ label }: { label: string }) {
  return (
    <div className="flex flex-col items-center gap-6" role="status" aria-live="polite">
      <div
        className="size-7 animate-spin rounded-full border-[3px] border-border border-t-brand"
        aria-hidden="true"
      />
      <span className="text-base text-text-muted">{label}</span>
    </div>
  );
}
